import React from "react";
import "./WhatsAppButton.css"; // Add styles for the floating button

const WhatsAppButton = () => {
  const phoneNumber = "918660891204"; // Replace with the recipient's WhatsApp number (in international format, without + or 00)
  const message = "Hello, I would like to know more about your services!"; // Your predefined message

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank"); // Opens WhatsApp Web or App in a new tab
  };

  return (
    <div>
      {/* Floating WhatsApp Button */}
      <button className="whatsapp-button" onClick={handleWhatsAppClick}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </button>
    </div>
  );
};

export default WhatsAppButton;
